import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  Center,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchJobSkillsAsync,
  selectJobSkills,
} from "../../../JobPostingSlice/JobSkillsList/JobSkillsSlice";
import {
  addJobEducationAsync,
  deleteJobEducationAsync,
  fetchJobEducationAsync,
  selectJobEducation,
  updateJobEducationAsync,
} from "../../../JobPostingSlice/JobEducation/JobEducationSlice";

function MinmQualif() {
  const dispatch = useDispatch();
  const jobEducation = useSelector(selectJobEducation);

  useEffect(() => {
    dispatch(fetchJobEducationAsync());
  }, []);

  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const [newJobEducation, setNewJobEducation] = useState("");
  const [newJobStatus, setNewJobStatus] = useState(""); // Add status state
  const [error, setError] = useState(null);
  const [editJobEducation, setEditJobEducation] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editJobStatus, setEditJobStatus] = useState("");
  const [editableJobEducation, setEditableJobEducation] = useState(null);
  const [deletingEducation, setDeletingEducation] = useState(null);

  useEffect(() => {
    dispatch(fetchJobEducationAsync());
  }, [dispatch]);

  const handleDelete = async (uuid) => {
    await dispatch(deleteJobEducationAsync(uuid));
    dispatch(fetchJobEducationAsync());
    onClose2();
  };

  const openDeleteModal = (job) => {
    setDeletingEducation(job);
    dispatch(fetchJobEducationAsync());
    onOpen2();
  };

  const handleSave = async () => {
    const jobEducation = {
      title: newJobEducation,
      status: "active", // Get status from input
    };

    try {
      await dispatch(addJobEducationAsync(jobEducation));

      dispatch(fetchJobEducationAsync());
      setNewJobEducation(""); // Clear input field after saving
      setNewJobStatus(""); // Clear status field
      onClose1();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleEdit = (jobEducation) => {
    setEditableJobEducation(jobEducation);
    setEditJobEducation(jobEducation.title);
    setEditJobStatus(jobEducation.status);
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (editJobEducation.trim()) {
      try {
        await dispatch(
          updateJobEducationAsync({
            uuid: editableJobEducation.uuid,
            jobEducationData: {
              title: editJobEducation,
              status: editJobStatus, // Include status
            },
          })
        );

        dispatch(fetchJobEducationAsync());
        setEditableJobEducation(null);
        setEditJobEducation("");
        setEditJobStatus(""); // Reset status
        setIsEditModalOpen(false);
      } catch (err) {
        setError(err.message);
      }
    }
  };

  return (
    <div
      className="h-screen bg-adminbg contentAdmin p-4"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="">
        <div className="w-full bg-white my-5 rounded-md">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              Minimum Qualification
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button
                colorScheme="blue"
                fontSize={"medium"}
                alignContent={"center"}
                onClick={onOpen1}
              >
                Add<i className="fa-solid fa-plus px-2"></i>
              </Button>

              <Modal isOpen={isOpen1} onClose={onClose1}>
                <ModalOverlay />
                <ModalContent maxW={"2xl"}>
                  <div className="p-4">
                    <h4 className="py-2">Add Degree:</h4>
                    <Input
                      className="border-black"
                      color="black"
                      placeholder="Enter Degree Title"
                      value={newJobEducation}
                      onChange={(e) => setNewJobEducation(e.target.value)}
                    />
                    <Input
                      className="border-black"
                      color="black"
                      placeholder="Enter Degree Status"
                      value={newJobStatus}
                      onChange={(e) => setNewJobStatus(e.target.value)}
                    />
                    <div className="w-full flex justify-center gap-2 mt-5">
                      <Button
                        colorScheme="blue"
                        className="w-64"
                        onClick={handleSave}
                      >
                        Save
                      </Button>
                      <Button
                        colorScheme="blue"
                        textColor={"blue"}
                        variant={"outline"}
                        className="w-64"
                        onClick={onClose1}
                      >
                        Cancel
                      </Button>
                    </div>
                    {error && <p className="text-red-500">{error}</p>}
                  </div>
                </ModalContent>
              </Modal>
            </div>
          </div>
          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/4">ID</Th>
                  <Th className="w-1/4">Title</Th>
                  <Th className="w-1/4">Status</Th>
                  <Th className="w-1/4">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {jobEducation.length > 0 ? (
                  jobEducation.map((job) => (
                    <Tr key={job.uuid}>
                      <Td>{job.uuid}</Td>
                      <Td>{job.title}</Td>
                      <Td textColor={"green"}>{job.status}</Td>
                      <Td>
                        <div className="text-sm opacity-90 text-blue-700 flex">
                          <div>
                            <i className="fa-solid fa-eye mr-3.5"></i>
                          </div>
                          <div>
                            <button onClick={() => handleEdit(job)}>
                              <i className="fa-solid fa-pencil mr-3.5"></i>
                            </button>
                            <Modal
                              isOpen={isEditModalOpen}
                              onClose={() => setIsEditModalOpen(false)}
                            >
                              <ModalOverlay />
                              <ModalContent maxW={"2xl"}>
                                <div className="p-4">
                                  <h4 className="py-2">Edit Degree Title:</h4>
                                  <Input
                                    className="border-black"
                                    color="black"
                                    placeholder="Enter Degree Title"
                                    value={editJobEducation}
                                    onChange={(e) =>
                                      setEditJobEducation(e.target.value)
                                    }
                                  />
                                  <Input
                                    className="border-black"
                                    color="black"
                                    placeholder="Enter Degree Status"
                                    value={editJobStatus}
                                    onChange={(e) =>
                                      setEditJobStatus(e.target.value)
                                    }
                                  />
                                  <div className="w-full flex justify-center gap-2 mt-5">
                                    <Button
                                      colorScheme="blue"
                                      className="w-64"
                                      onClick={handleUpdate}
                                    >
                                      Update
                                    </Button>
                                    <Button
                                      colorScheme="blue"
                                      textColor={"blue"}
                                      variant={"outline"}
                                      className="w-64"
                                      onClick={() => setIsEditModalOpen(false)}
                                    >
                                      Cancel
                                    </Button>
                                  </div>
                                  {error && (
                                    <p className="text-red-500">{error}</p>
                                  )}
                                </div>
                              </ModalContent>
                            </Modal>
                          </div>
                          <div className="">
                            <button onClick={() => openDeleteModal(job)}>
                              <i className="cursor-pointer fa-solid fa-trash-can-arrow-up mr-3.5"></i>
                            </button>
                            <Modal
                              isOpen={isOpen2}
                              onClose={onClose2}
                              alignContent={Center}
                            >
                              <ModalOverlay />
                              <ModalContent maxW={"2xl"}>
                                <div className="p-4">
                                  <h4 className="py-2">
                                    Are you sure you want to delete "
                                    {deletingEducation?.title}"?
                                  </h4>
                                  <div className="w-full flex justify-center gap-2 mt-4">
                                    <Button
                                      colorScheme="red"
                                      className="w-48"
                                      onClick={() =>
                                        handleDelete(deletingEducation.uuid)
                                      }
                                    >
                                      Delete
                                    </Button>
                                    <Button
                                      colorScheme="red"
                                      textColor={"red"}
                                      variant={"outline"}
                                      className="w-48"
                                      onClick={onClose2}
                                    >
                                      Cancel
                                    </Button>
                                  </div>
                                </div>
                              </ModalContent>
                            </Modal>
                          </div>
                        </div>
                      </Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan="4" className="text-center py-4 text-gray-500">
                      No data available
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default MinmQualif;